<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeModal(false)" />
</div>

<ion-content>
  <div>
    <ion-grid class="grid-style">
      <ion-row>
        <ion-col>
          <ion-title class="smaller overskrift">
            <h1>{{fakturaObject.mnd}}&nbsp;-&nbsp;{{fakturaObject.aar}}</h1>
          </ion-title>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div [ngSwitch]="fakturaStatus">
            <h2
              *ngSwitchCase="'ikke'"
              class="ikkebetalt"
              [class.harforfalt]="harRegningForfalt"
            >
              Ikke betalt
            </h2>
            <h2 *ngSwitchCase="'betalt'" class="betalt">Betalt</h2>
            <h2 *ngSwitchCase="'kreditert'" class="status">Kreditert</h2>
            <h2 *ngSwitchCase="'kreditfaktura'" class="status">
              Kreditfaktura
            </h2>
            <h2 *ngSwitchCase="'overført'" class="status">Overført</h2>
            <h2 *ngSwitchDefault class="status">{{fakturaObject.status}}</h2>
          </div>

          <div
            *ngIf="isOriginalKunde &&
                isBetalingsutsettelseToggled &&
                fakturaObject.kanUtsette &&
                fakturaObject.status.trim() === 'Ikke betalt' &&
                !fakturaObject.betalingsavtale"
          >
            <ion-button
              class="marginBottom secondary"
              (click)="openBetalingsutsettelse()"
            >
              Betalingsutsettelse
              <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
            </ion-button>
          </div>
          <ion-modal
            #betalingsutsettelsemodal
            [isOpen]="showBetalingsutsettelse"
            cssClass="betalingsutsettelse-modal-content"
            (didDismiss)="dismissUtsettelse()"
            backdropDismiss
          >
            <ng-template>
              <app-utsette-betaling
                [faktura]="faktura"
                (dueDateChanged)="emitDueDateChanged()"
              >
              </app-utsette-betaling>
            </ng-template>
          </ion-modal>

          <p
            class="utsatt-regning"
            *ngIf="
                !fakturaObject.kanUtsette &&
                fakturaObject.status.trim() === 'Ikke betalt' &&
                fakturaObject.betalingsavtale
              "
          >
            Regning utsatt til {{
            formatDateToString(fakturaObject.endeligForfall) }}
          </p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="kakediagram-col">
          <canvas class="kakediagram" #mychart></canvas>
        </ion-col>
      </ion-row>
      <ion-row class="kraftrow">
        <ion-col size="5">
          <span class="kraft">
            <div class="chartbox xkraft">&nbsp;</div>
            Kraft
          </span>
          <span
            class="nettleie"
            [class.pointer]="showNettleie"
            (click)="getNettleiePdf()"
          >
            <span class="chartbox xnettleie">&nbsp;</span> Nettleie
          </span>
          <span class="sum">Sum</span>
        </ion-col>
        <ion-col size="7" class="alignRight">
          <span class="kraft">{{fakturaObject.belopKraft}} kr</span>
          <span class="nettleie">{{fakturaObject.belopNettleie}} kr</span>
          <span class="sum">{{fakturaObject.belopTotal}} kr</span>
        </ion-col>
      </ion-row>
      <!--<ion-row class="nettleie">
            <ion-col size="4">
                <div (click)="getNettleiePdf()">Nettleie</div>
            </ion-col>
            <ion-col size="4"></ion-col>
            <ion-col size="4">
                {{fakturaObject.belopNettleie}}
            </ion-col>
        </ion-row>
        <ion-row class="sum">
            <ion-col offset="2">Sum</ion-col>
            <ion-col>{{fakturaObject.belopTotal}}</ion-col>
        </ion-row>
    -->
      <ion-row>
        <ion-col class="info-section-faktura">
          <ion-row>
            <ion-col>
              <h2>Betalingsinformasjon</h2>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="4" class="kidkolonne">
              <p>KID</p>
              <p>Kontonr</p>
              <p>Beløp</p>
              <p>Periode</p>
              <p>Forfall</p>
              <p>Status</p>
            </ion-col>
            <ion-col size="8" class="kidkolonne alignRight">
              <p
                id="mykid"
                class="hover flexStart"
                (click)="copyToClipboard(fakturaObject.kid)"
              >
                {{fakturaObject.kid}}&nbsp;
                <ion-icon name="clipboard-outline" slot="end"></ion-icon>
              </p>
              <p
                id="myknr"
                class="hover flexStart"
                (click)="copyToClipboard('15038799999')"
              >
                1503.87.99999&nbsp;
                <ion-icon name="clipboard-outline"></ion-icon>
              </p>
              <p>{{fakturaObject.belopTotal}} kr</p>
              <p>
                {{formatDateToString(fakturaObject.fradato, 'short') }} –
                {{formatDateToString(fakturaObject.tildato, 'short')}}
              </p>
              <div>
                <p
                  *ngIf="fakturaObject.forfdato == fakturaObject.endeligForfall"
                >
                  {{formatDateToString(fakturaObject.forfdato)}}
                </p>
                <p
                  *ngIf="fakturaObject.forfdato != fakturaObject.endeligForfall"
                >
                  <span class="oldForfall"
                    >{{formatDateToString(fakturaObject.forfdato)}}</span
                  >
                  &nbsp;<span
                    >{{formatDateToString(fakturaObject.endeligForfall)}}</span
                  >
                </p>
              </div>
              <p>{{fakturaObject.status}}</p>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="ion-margin-top">
              <ion-button class="dark" (click)="getPdf()">
                <ion-icon name="attach-outline"></ion-icon> Se regning
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
